import { Product } from '../../types/Product';

interface TrendAnalysis {
  increases: Array<{
    name: string;
    change: number;
    currentPrice: number;
  }>;
  decreases: Array<{
    name: string;
    change: number;
    currentPrice: number;
  }>;
}

export const analyzeTrends = (products: Product[]): TrendAnalysis => {
  const priceChanges = products
    .filter(p => p.price_decreased || p.previous_price > p.current_price)
    .map(product => {
      const change = ((product.current_price - product.previous_price) / product.previous_price) * 100;
      return {
        name: product.display_name,
        change,
        currentPrice: product.current_price
      };
    });

  const increases = priceChanges
    .filter(p => p.change > 0)
    .sort((a, b) => b.change - a.change)
    .slice(0, 5);

  const decreases = priceChanges
    .filter(p => p.change < 0)
    .sort((a, b) => a.change - b.change)
    .slice(0, 5);

  return { increases, decreases };
};